class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    // Update cart icon count without replacing the entire structure
    this.updateCartIconCount(parsedState);

    if (this.header) this.header.reveal();
    this.open();
  }

  updateCartIconCount(parsedState) {
    const cartIconBubble = document.getElementById("cart-icon-bubble");
    if (!cartIconBubble) return;

    // Get the cart count from the parsed state
    const cartCount = parsedState.item_count;
    
    // If cart is not empty, update to the not-empty state
    if (cartCount > 0) {
      // Check if we need to transform from empty to not-empty state
      const emptyContainer = cartIconBubble.querySelector(".item-cart-container-empty");
      if (emptyContainer) {
        const itemCartContainer = cartIconBubble.querySelector(".item-cart-container");
        if (itemCartContainer) {
          // Create the not-empty container
          itemCartContainer.innerHTML = `
            <div class="item-cart-container-not-empty">
              <img class="icon-shopping-cart" src="https://cdn.shopify.com/s/files/1/0717/3380/5285/files/icon-shopping-cart.svg?v=1738033409">
              <div class="item-cart-text">Cart</div>
              <div class="item-cart-counter-container">
                <div class="item-cart-counter">${cartCount}</div>
              </div>
            </div>
          `;
        }
      } else {
        // Just update the counter
        const counter = cartIconBubble.querySelector(".item-cart-counter");
        if (counter) {
          counter.textContent = cartCount;
        }
      }
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
